export const ORDER_SOURCES = [
  { id: 'all', label: 'All sources' },
  { id: 'public_web', label: 'Online (Web)' },
  { id: 'admin', label: 'Admin / Internal' },
  { id: 'rep_mobile', label: 'Rep (Mobile)' },
];

export const SALES_CHANNEL_FILTERS = [
  { id: 'all', label: 'All sales' },
  { id: 'direct', label: 'Direct sales' },
  { id: 'rep', label: 'Rep sales' },
];

export const ORDER_SOURCE_LABELS = {
  public_web: 'Online (Web)',
  admin: 'Admin / Internal',
  rep_mobile: 'Rep (Mobile)',
};

export const ORDER_SOURCE_STYLES = {
  public_web: 'bg-sky-100 text-sky-800',
  admin: 'bg-violet-100 text-violet-800',
  rep_mobile: 'bg-emerald-100 text-emerald-800',
};

export const SALES_CHANNEL_LABELS = {
  direct: 'Direct sale',
  rep: 'Rep sale',
};

export const SALES_CHANNEL_STYLES = {
  direct: 'bg-amber-100 text-amber-800',
  rep: 'bg-blue-100 text-blue-800',
};

export function normalizeOrderSource(value) {
  const key = String(value || 'admin').trim().toLowerCase();
  if (key === 'public_web' || key === 'admin' || key === 'rep_mobile') return key;
  return 'admin';
}

export function resolveOrderSourceLabel(order) {
  if (order?.order_source_label) return order.order_source_label;
  return ORDER_SOURCE_LABELS[normalizeOrderSource(order?.order_source)] || 'Admin / Internal';
}

export function resolveSalesChannelLabel(order) {
  if (order?.sales_channel_label) return order.sales_channel_label;
  const channel = order?.sales_channel || (order?.is_direct_sale ? 'direct' : 'rep');
  return SALES_CHANNEL_LABELS[channel] || 'Rep sale';
}

export function orderMatchesSourceFilter(order, sourceFilter) {
  if (!sourceFilter || sourceFilter === 'all') return true;
  return normalizeOrderSource(order?.order_source) === sourceFilter;
}

export function orderMatchesChannelFilter(order, channelFilter) {
  if (!channelFilter || channelFilter === 'all') return true;
  const channel = order?.sales_channel || (order?.is_direct_sale ? 'direct' : 'rep');
  return channel === channelFilter;
}

export function summarizeOrdersByDimensions(orders = []) {
  const empty = () => ({ order_count: 0, revenue_inr: 0 });
  const bySource = {
    public_web: empty(),
    admin: empty(),
    rep_mobile: empty(),
  };
  const bySalesChannel = {
    direct: empty(),
    rep: empty(),
  };

  for (const order of orders) {
    const amount = parseFloat(order.order_amount) || 0;
    const source = normalizeOrderSource(order.order_source);
    const channel = order.sales_channel || (order.is_direct_sale ? 'direct' : 'rep');
    if (bySource[source]) {
      bySource[source].order_count += 1;
      bySource[source].revenue_inr += amount;
    }
    if (bySalesChannel[channel]) {
      bySalesChannel[channel].order_count += 1;
      bySalesChannel[channel].revenue_inr += amount;
    }
  }

  return { bySource, bySalesChannel };
}
